export default (url) => {
    var regExp = /^https?:\/\/(?:[\w-]+\.)+[a-z]{2,}(?:\/[\w-.\/?%&=]*)?$/i;
    var match = url.match(regExp);
    return match !== null;
}